const region = "us-east-1";
const origin = window.location.origin;

const qa = {
  appSettingsData: {
    // generate a file format limit of video file
    federatedEngageAIProvider: "wl-qa-translate-client-site-idp",
  },

  amplify_config: {
    Auth: {
      mandatorySignIn: true,
      region: region,
      userPoolId: "us-east-1_rP6dlu9dU",
      userPoolWebClientId: "55e6jf4vgjg703qn73o3fnpmk3",
    },
    oauth: {
      domain: "wl-qa-engage-translate-client-site.auth.us-east-1.amazoncognito.com",
      scope: [],
      redirectSignIn: `${origin}/view`,
      redirectSignOut: `${origin}/`,
      responseType: "code",
      clientId: "55e6jf4vgjg703qn73o3fnpmk3",
    },
    API: {
      endpoints: [
        {
          name: "engage-translate",
          endpoint: "https://api.qa.translate.wl-engage.com",
          region: region,
        },
      ],
    },
  },
};

export type QaType = typeof qa;
export default qa;
